export default defineNuxtRouteMiddleware((to, from) => {
    // Questo middleware verifica se si tenta di accedere ad un url diverso da questo percorso:
    // 1. /categoria/:slug/record-:id
    // 2. /categoria/:slug/

    // Se il fullpath inizia con /categoria/:slug/, verifica se è presente altro nell'url.
    // Se c'è e non è composta da record-#### reindirizza alla pagina padre
    // ES: /categoria/abbigliamento/test -> /categoria/abbigliamento/
    // N.B. to.params.slug non è presente in quanto non è un parametro della route, ma è presente in to.fullPath
    if (to.fullPath.startsWith('/categoria/') && to.fullPath.split('/').length > 3 && !to.fullPath.includes('record-')) {
        return navigateTo(`/categoria/${to.fullPath.split('/')[2]}`)
    }
})